import { render } from "./role.vue?vue&type=template&id=1ae250f8&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import "./role.vue?vue&type=style&index=0&id=1ae250f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ae250f8"

export default script